
import React, { useEffect, useState } from 'react'

import { useParams } from 'react-router-dom'
import { Navigate, useNavigate } from 'react-router-dom';

const CompletedReload = () => {
  let params = useParams();
  const navigate = useNavigate()

  useEffect(() => {
    console.log("CompletedReload.jsx: Loaded with params:", params);
    if (params.reload == 1) {
      const pluginProduct = localStorage.getItem('plugin_product');
      const basePath = pluginProduct ? pluginProduct.toLowerCase() : 'aurora';
      const finalUrl = `/${basePath}/lic/${2}/${params.machineid}/${params.useremail}`;
      console.log("CompletedReload.jsx: Reload == 1. Navigating to final URL:", finalUrl);
      navigate(finalUrl);
      window.location.reload();
    } else {
      console.log("CompletedReload.jsx: Reload != 1, doing nothing. Current URL:", window.location.href);
    }
  }, [])

  return (
    <div className="salepage__img">
      {/* <img src={bgImg} alt="img" className='salepage__imgsize' />*/}
      <div style={{ position: 'absolute', top: 10, left: 10, color: 'white', fontSize: '12px' }}>
        CompletedReload: {window.location.href}
      </div>
    </div>
  )
}

export default CompletedReload